export default {
  cards: state => state.cards,
  filters: state => state.filters,
  currentPage: state => state.currentPage,
  lastPage: state => state.lastPage,
  totalItems: state => state.totalItems,
  isCallingCards: state => state.isCallingCards,
  tableColumns: state => state.tableColumns,
  isLoadingCards: state => state.isLoadingCards,
  isLoadingNextPageCards: state => state.isLoadingNextPageCards
}
